<div class='ar-accounts-main' data-cy="ar-account-config-container">
  <mat-progress-spinner *ngIf="tableModel === undefined" style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)" diameter="100" mode="indeterminate" data-cy="ar-account-config-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="tableModel !== undefined" cols="6" rowHeight="100%" style="height:100%;" data-cy="ar-account-config-grid">
    <mat-grid-tile colspan="2" data-cy="ar-account-config-list-tile">
      <mat-card appearance="outlined" style="width:100%; height: calc(100%); display: flex; flex-direction: column;" data-cy="ar-account-config-list-card">
        <span class="configuration-section-title" data-cy="ar-account-config-list-title">AR Accounts</span>
        <div style="flex: 1; max-height: 100%; overflow-y: hidden;" data-cy="ar-account-config-table-container">

          <app-tdo-table #accountsTable [sortActive]="true" [isSearchable]="false" *ngIf="tableModel !== undefined" [tdoTableModel]="tableModel" (actionClick)="onTdoTableItemActionClick($event)" (itemSelected)="onTdoTableItemClick($event)" data-cy="ar-account-config-table"></app-tdo-table>

        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="ar-account-config-details-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="ar-account-config-details-card">
        <mat-card-content data-cy="ar-account-config-details-content">
          <div style="max-width: 700px;" data-cy="ar-account-config-details-container">
            <span class="configuration-section-title" data-cy="ar-account-config-details-title">AR Account Information</span>
            <app-tdo-configuration-action-bar
              #actionBar
              [showEdit]="(!isEditing && this.accountList.length > 0)"
              (editClick)="onEdit($event)"
              [saveDisabled]="saveDisabled"
              [showSave]="!saveDisabled"
              [showCancel]="!saveDisabled"
              (saveClick)="onSave($event)"
              (cancelClick)="onCancel($event)"
              (newClick)="onNew($event)"
              [showAdd]="false"
              [newHidden]="false"
              data-cy="ar-account-config-action-bar">
            </app-tdo-configuration-action-bar>

            <div *ngIf="this.selectedAccount" data-cy="ar-account-config-form">

                  <app-tdo-input
                    style="width:100%"
                    [(ngModel)]="this.selectedAccount.AccountName"
                    placeholder="Account Name"
                    (change)="configurationService.setDirty();"
                    [disabled]="!this.isEditing"
                    data-cy="ar-account-config-name-input">
                  </app-tdo-input>

                  <app-tdo-input
                    style="width:100%"
                    [(ngModel)]="this.selectedAccount.AccountNumber"
                    placeholder="Account Number"
                    (change)="configurationService.setDirty();"
                    [disabled]="!this.isEditing"
                    data-cy="ar-account-config-number-input">
                  </app-tdo-input>

            </div>
            <div *ngIf="this.isLoading" data-cy="ar-account-config-loading-container">
              <mat-spinner style="margin-left: auto; margin-right: auto;" data-cy="ar-account-config-details-spinner"></mat-spinner>
            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>


